module.exports = __webpack_public_path__ + "img/cooperation_unit_16.bcc01c17.jpg";